import { useQuery } from '@tanstack/react-query';

import { DataTable } from '@/components/composed/DataTable/DataTable';
import type {
  EntityContract,
  EntityContractListParams,
} from '@/lib/api/domains/entity-contracts';
import { entityContractListQuery } from '../api/entity-contract-queries';
import { entityContractColumns } from './entity-contract-columns';

export function EntityContractTable({
  params,
  onPageChange,
  onRowClick,
}: {
  params: EntityContractListParams;
  onPageChange: (page: number) => void;
  onRowClick?: (contract: EntityContract) => void;
}) {
  const query = useQuery(entityContractListQuery(params));

  return (
    <DataTable<EntityContract>
      columns={entityContractColumns}
      data={query.data?.items ?? []}
      getRowId={(row) => row.id}
      tableId="entity-contracts"
      isLoading={query.isLoading}
      isError={query.isError}
      errorMessage="Failed to load contracts."
      emptyTitle="No contracts found"
      page={query.data?.page ?? params.page ?? 1}
      pageSize={query.data?.pageSize ?? params.pageSize ?? 25}
      total={query.data?.total ?? 0}
      onPageChange={onPageChange}
      {...(onRowClick ? { onRowClick } : {})}
    />
  );
}
